showDetailsPlanInCart('.show-details-plan', '.box-details-plan', '.resume-plan-chosen', '.btn-close-details-plan');

function showDetailsPlanInCart(btnShow, contentDetails, contentPrev, btnCloseDetails) {
    const select = (element) => document.querySelector(element);
    const selectAll = (element) => document.querySelectorAll(element);


    selectAll(btnShow).forEach(btn => {
        btn.addEventListener('click', ()=> {
            select(contentDetails).classList.toggle('d-none');
            select(contentPrev).classList.toggle('d-none');

            select('.btn-detalhes').classList.toggle('d-none');
            select('.btn-resumo').classList.toggle('d-none');
        })
    })

    selectAll(btnCloseDetails).forEach(btn => {
        btn.addEventListener('click', ()=> {
            select(contentDetails).classList.add('d-none');
            select(contentPrev).classList.remove('d-none');

            select('.btn-detalhes').classList.toggle('d-none');
            select('.btn-resumo').classList.toggle('d-none');
        })
    })


}
